export const videoIdArray = [
  // {
  //   id: "zmsrdyPUJHM", //1
  // },
  {
    id: "72rNNtvz8_w", //2
  },
  {
    id: "fJ-tvyj3Jlc", //3
  },
  {
    id: "haO0HqyrAuU", //4
  },
  {
    id: "RSFIGFQ-jDk", //5
  },
  {
    id: "BxpixkJsGn0", //6
  },
  {
    id: "_y1p0P2YeWQ", //7
  },
  {
    id: "8NF7NjID90k", //8
  },
  {
    id: "NH5U8xAKdso", //9
  },
  {
    id: "82coAgQDExg", //10
  },
];

export const imagePath =
  "https://stagingresources.swmc.com/swmc-images/Chris-Pavan";
export const generateYtThumbnail = (idPassed) =>
  `${process.env.REACT_APP_CDN_IMAGES_CP}${idPassed}.webp`;

export const generateYtVideoLink = (idPassed) =>
  `https://www.youtube.com/watch?v=${idPassed}&authuser=0`;

export const dragElement = (elmnt, holderEle) => {
  // (myDIv, myDiveader is holding element for this for this)
  // console.log('DragFn:', elmnt)
  var pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;
  if (document.getElementById(elmnt.id + "header")) {
    /* if present, the header is where you move the DIV from:*/
    document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
  } else if (holderEle && holderEle.length > 0) {
    /* if present, the header is where you move the DIV from:*/
    holderEle[0].onmousedown = dragMouseDown;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    // calculate the new cursor position:
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    // set the element's new position:
    elmnt.style.top = elmnt.offsetTop - pos2 + "px";
    elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
  }

  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    document.onmouseup = null;
    document.onmousemove = null;
  }
};
